import type { Member, MemberSummary, TeamMatchPlayResults, CurrentRyderCupTeamMember } from '../types/api.types';
import { MemberCard } from './member-card';
import { calculatePlayer2MatchSummary } from './head-to-head.utils';

interface OpponentsPanelProps {
  memberEntities: Record<string, MemberSummary>;
  selectedMember: string | number | null;
  selectedOpponent: string | number | null;
  onOpponentSelect: (id: string | number | null) => void;
  opponentIds: (string | number)[];
  player1Results: Record<string | number, TeamMatchPlayResults[]> | undefined;
  showLatestRyderCupOnly: boolean;
  latestRyderCupTeams: CurrentRyderCupTeamMember[];
}

export function OpponentsPanel({
  memberEntities,
  selectedMember,
  selectedOpponent,
  onOpponentSelect,
  opponentIds,
  player1Results,
  showLatestRyderCupOnly,
  latestRyderCupTeams,
}: OpponentsPanelProps) {
  const getContent = () => {
    if (!selectedMember) {
      return ['Select a player to see past opponents'];
    }

    if (opponentIds.length === 0) {
      return showLatestRyderCupOnly
        ? ['No members found on the opposing team']
        : ['No results found for selected Player 1'];
    }

    return opponentIds.map((opponentId) => {
      const opponentDetails = memberEntities[opponentId] as Member | undefined;
      if (!opponentDetails) return `Opponent (${opponentId}) not found`;

      return (
        <MemberCard
          key={opponentDetails.id}
          member={opponentDetails}
          isSelected={selectedOpponent === opponentDetails.id}
          matchSummary={calculatePlayer2MatchSummary(player1Results, opponentDetails.id, selectedMember)}
          onClick={() => onOpponentSelect(selectedOpponent === opponentDetails.id ? null : opponentDetails.id)}
          showLatestRyderCupOnly={showLatestRyderCupOnly}
          latestRyderCupTeams={latestRyderCupTeams}
          reverse={true}
        />
      );
    });
  };

  return (
    <div style={{ flex: '0 0 30%', display: 'flex', flexDirection: 'column' }}>
      <div
        style={{
          flex: 1,
          overflowY: 'auto',
          border: '1px solid #ccc',
          borderRadius: '4px',
          padding: '12px',
          background: '#fafafa',
        }}
      >
        {getContent()}
      </div>
    </div>
  );
}
